// extracted by mini-css-extract-plugin
export default {"container":"_318a2d99","tileWidth":"_23bc7aec"};